export const COMPLETE_LABEL_KEY = 'DEAL_PAYROLL_OPEN_BREAKDOWN';
export const INCOMPLETE_LABEL_KEY = 'DEAL_PAYROLL_OPEN_BREAKDOWN_INCOMPLETE';
export const DISABLED_LABEL_KEY = 'DEAL_PAYROLL_OPEN_BREAKDOWN_DISABLED';
export const DISABLED_PREVIEW_LABEL_KEY = 'DEAL_PAYROLL_OPEN_BREAKDOWN_DISABLED_PREVIEW';
export const FIRST_AMOUNT_INDEX = 0;
export const MODIFIER_SOURCE_KEY = '__dealPayrollModifierSource';
export const REMOTE_MODIFIER_SOURCE = 'REMOTE';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/deal-payroll-report-presentation.constants.ts